var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveDraftCustomization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1261 2C10.4775 2.00501 10.8128 2.14868 11.0588 2.39974L13.5905 4.93142C13.8416 5.17744 13.9852 5.51269 13.9902 5.86415V12.6597C13.9902 13.0131 13.8498 13.352 13.6 13.6019C13.3501 13.8518 13.0112 13.9922 12.6578 13.9922H3.33051C2.97712 13.9922 2.6382 13.8518 2.38832 13.6019C2.13843 13.352 1.99805 13.0131 1.99805 12.6597V3.33247C1.99805 2.97907 2.13843 2.64016 2.38832 2.39027C2.6382 2.14038 2.97712 2 3.33051 2H10.1261Z",
    stroke: "#424242",
    strokeWidth: 1.33247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3264 13.9939V9.3303C11.3264 9.1536 11.2562 8.98414 11.1313 8.8592C11.0063 8.73425 10.8369 8.66406 10.6602 8.66406H5.3303C5.1536 8.66406 4.98414 8.73425 4.8592 8.8592C4.73425 8.98414 4.66406 9.1536 4.66406 9.3303V13.9939",
    stroke: "#424242",
    strokeWidth: 1.33247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 2V4.66493C4.66406 4.84163 4.73425 5.01109 4.8592 5.13603C4.98414 5.26097 5.1536 5.33116 5.3303 5.33116H9.99392",
    stroke: "#424242",
    strokeWidth: 1.33247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveDraftCustomization);
export default __webpack_public_path__ + "static/media/MoveDraft-customization.80a60c4c6630dbabf585ef83e0990b92.svg";
export { ForwardRef as ReactComponent };